<!--sidebar-->
<c-sidebar
  #mainMenuSidebar="cSidebar"
  class="d-print-none sidebar sidebar-fixed border-end"
  id="mainMenuSidebar"
  visible
>
  <c-sidebar-header class="border-bottom">
    <c-sidebar-brand [routerLink]="[]">
      <app-logo></app-logo>
      <!-- <svg [class]="{icon: false}" cIcon class="sidebar-brand-full" height="32" name="logo" title="Logo"></svg> -->
      <!-- <svg cIcon class="sidebar-brand-narrow" height="32" name="app-logo" title="CoreUI Logo"></svg> -->
    </c-sidebar-brand>
    <span class="version">Version {{ version }}</span>
    <!-- <button cSidebarToggle="sidebar"
            cButtonClose
            class="d-lg-none"
            toggle="visible">
    </button> -->
  </c-sidebar-header>

  <ng-scrollbar pointerEventsMethod="scrollbar" visibility="hover">
    <!-- dropdownMode="path": a nav group (e.g. Global Health's "Administration") opens only
         while one of its routes is active and starts CLOSED otherwise — "none" left every
         group expanded on first render, which is exactly the admin clutter a member-facing
         dashboard must not show by default. -->
    <c-sidebar-nav [navItems]="navItems$()" dropdownMode="path" compact />
  </ng-scrollbar>

  @if (!mainMenuSidebar.narrow) {
    <!-- <c-sidebar-footer class="border-top d-none d-lg-flex"> -->
    <c-sidebar-footer class="border-top d-flex">
      <div class="policy" (click)="policy($event)">
        <svg cIcon name="cilShieldCheck"></svg>
        <a>Policy</a>
      </div>
      <!-- Cookie settings (Tracking Engine V2): renders nothing in apps without the banner. -->
      <div class="policy cookie-settings">
        <app-cookie-settings-link />
      </div>
      
      <!-- <c-sidebar-toggler toggle="unfoldable" csidebartoggle="mainMenuSidebar">
      <c-sidebar-toggler> -->

      <!-- <div cSidebarToggle="mainMenuSidebar" toggle="unfoldable"> -->
      <!-- <div cSidebarToggle="mainMenuSidebar" toggle="visible">
        <button cSidebarToggler aria-label="Toggle sidebar fold"></button>
      </div> -->
    </c-sidebar-footer>
  }
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column">
  <!-- specify e.g. class="mb-4 d-print-none header header-sticky p-0 shadow-sm" to add margin-bottom -->
  <app-default-header
    (openUserEditModal)="showUserEditModal = true"
    [cShadowOnScroll]="'sm'"
    class="mb-0 d-print-none header header-sticky p-0 shadow-sm"
    position="sticky"
    sidebarId="mainMenuSidebar"
    [badge]="showBadge()"
  />
  <app-impersonation-banner />
  <div class="body flex-grow-1">
    <c-container
      style="display:contents"
      [@contentTransition]="getAnimationState(outlet)">
      <router-outlet #outlet="outlet"/>
    </c-container>
  </div>
  <!--
  <app-default-footer />
  -->
</div>

<!--aside-->
<!-- <app-default-aside style="display: none;" /> -->
